// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tippy-box[data-theme~='bbbtip']{
    color:#fff;
    background-color:#333333;
    padding: .25rem .5rem;
    border-radius: 4px;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.tippy-box[data-theme~='bbbtip']>.tippy-svg-arrow{
    fill: #333333;
    background-color: transparent;
}

.tippy-box[data-theme~='bbbtip']>.tippy-content{
    text-wrap: pretty;
}
`, "",{"version":3,"sources":["webpack://./imports/ui/components/common/tooltip/bbbtip.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAiB;OAAjB,sBAAiB;QAAjB,qBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".tippy-box[data-theme~='bbbtip']{\r\n    color:#fff;\r\n    background-color:#333333;\r\n    padding: .25rem .5rem;\r\n    border-radius: 4px;\r\n    user-select: none;\r\n}\r\n\r\n.tippy-box[data-theme~='bbbtip']>.tippy-svg-arrow{\r\n    fill: #333333;\r\n    background-color: transparent;\r\n}\r\n\r\n.tippy-box[data-theme~='bbbtip']>.tippy-content{\r\n    text-wrap: pretty;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
